
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Reveal } from './Reveal';

export const QuoteSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="py-24 md:py-48 bg-rabbit-navy relative overflow-hidden border-y border-gray-800">
      {/* Subtle ambient light */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[400px] bg-blue-500/5 blur-[120px] pointer-events-none"></div>

      <div className="max-w-5xl mx-auto px-6 text-center relative z-10">
        <Reveal>

          {/* Minimalist Separator */}
          <div className="mb-12 md:mb-16 flex justify-center">
            <div className="h-px w-24 bg-clever-teal"></div>
          </div>

          {/* Quote Headline - Fixed Line Height to 1.5 via inline style */}
          <h2 className="text-3xl md:text-5xl font-light text-gray-100 mb-12 md:mb-16 font-sans tracking-tight" style={{ lineHeight: '1.5' }}>
            "{t('quote.text_part1')} <span className="text-white font-medium bg-red-600/20 px-2 py-0.5 rounded box-decoration-clone">{t('quote.highlight')}</span>. {t('quote.text_part2')}"
          </h2>

          <div className="flex flex-col items-center justify-center gap-2">
            <div className="font-bold text-white tracking-wide text-lg">{t('quote.author')}</div>
            <div className="text-xs font-medium text-gray-500 uppercase tracking-widest">{t('quote.role')}</div>
          </div>

        </Reveal>
      </div>
    </section>
  );
};
